"use strict";

class FadingWords {

    constructor(element) {
        this.element = document.getElementById(element);
        this.words = window.FADING_WORDS;
        this.currentIndex = 0;
        this.fadingEl = this.element.querySelector('h1 strong');
        this.primaryWord = null;
        this.run();
    }

    run() {
        setInterval(() => {
            this.fadingEl.style.opacity = 0;

            setTimeout(() => {
                this.currentIndex = (this.currentIndex + 1) % this.words.length;
                this.fadingEl.innerHTML = this.words[this.currentIndex];
                this.fadingEl.style.opacity = 1;
            }, 500);

        }, 3000)
    }

}

// init
new FadingWords('site-header');
